import { Component, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { ResumenLotesService, LoteSummaryDTO } from '../../services/resumen-lotes.service';

@Component({
  selector: 'app-modal-resumen',
  templateUrl: './modal-resumen.component.html',
  styleUrls: ['./modal-resumen.component.scss']
})
export class ModalResumenComponent {
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();
  lotes: LoteSummaryDTO[] = [];
  private isLoading = false;

  constructor(private resumenLotesService: ResumenLotesService) { }

  ngOnChanges(changes: SimpleChanges): void {
    const isOnlineRaw = localStorage.getItem('isStillOnline');
    const isOnline = isOnlineRaw ? JSON.parse(isOnlineRaw) : false;

    if (changes.isOpen?.currentValue && isOnline && !this.isLoading) {
      this.loadResumenLotes();
    }
  }

  async openModal(): Promise<void>  {
    this.isOpen = true;
  }

  async loadResumenLotes(): Promise<void> {
    if (this.isLoading) return;
    this.isLoading = true;

    try {
      const currentUserString = sessionStorage.getItem('currentUser');
      const idPrestador = currentUserString ? JSON.parse(currentUserString).modelId : null;
      const response = await this.resumenLotesService.getResumenLotes(idPrestador).toPromise();
      this.lotes = response.response.listaResumen;
    } catch (error) {
      console.error('Error al cargar los lotes', error);
    } finally {
      this.isLoading = false;
    }
  }

  async updateData(): Promise<void>{
    this.lotes = [];
    await this.loadResumenLotes();
  }

  closeModal(): void {
    this.isOpen = false;
    this.lotes = [];
    this.close.emit();
  }

}
